<template>
  <div>
    <list
      row-key="TradeUnitId"
      ref="list"
      unit="供应商"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list2"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单位名称">
          <el-input size="mini" v-model="params.TradeUnitName" placeholder="请输入单位名称" clearable />
        </el-form-item>
         <el-form-item label="付款条件">
          <el-select size="mini" v-model="params.PayMode" placeholder="请选择" clearable>
            <el-option
              v-for="item in payList"
              :key="item.PayConditionId"
              :label="item.PayConditionName"
              :value="item.PayConditionId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分管部门">
          <el-input size="mini" v-model="params.DpName" placeholder="请输入部门名称" clearable />
        </el-form-item>
        <el-form-item label="分管人员">
          <el-input size="mini" v-model="params.EmpName" placeholder="请输入人员名称" clearable />
        </el-form-item>
        <el-form-item label="状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
            <el-option label="冻结" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input size="mini" v-model="params.Remark" placeholder="请输入备注" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="TradeUnitName" label="单位名称" min-width="110px" />
        <el-table-column prop="Remark" label="备注" min-width="110px" />
        <el-table-column prop="FirstPerson" label="主要联系人" min-width="100px" />
        <el-table-column prop="Phone" label="联系电话" min-width="100px" />
        <el-table-column prop="Status" label="状态" width="80px" align="center">
          <template slot-scope="{row}">
            <el-tag size="mini" v-if="row.Status==0" type="danger">停用</el-tag>
            <el-tag size="mini" v-else-if="row.Status==1" type="success">正常</el-tag>
            <el-tag size="mini" v-else type="info">冻结</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="DpName" label="分管部门" min-width="100px" />
        <el-table-column prop="EmpName" label="分管人员" min-width="100px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      payApi: require("@/api/sy/paycondition").default,
      // api: require("@/api/ba/supplier").default,
      api: require("@/api/ba/tradeUnit").default,
      params: {
        TradeUnitName: "",
        DpName: "",
        EmpName: "",
        PayMode: "",
        Status: null,
        TradeUnitType:2,
        Remark:''
      },
      payList: [],
    };
  },
  mounted(){
    this.payApi.list({ PageIndex: 1, PageSize: 100 }).then((res) => {
      this.payList = res.Data;
      res.Data.forEach(e => {
        e.PayConditionId=String(e.PayConditionId)
      });
      sessionStorage.setItem("payList", JSON.stringify(res.Data));
    });
  },
  methods: {
    delRange(ids) {
      
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>